/**
 * Frontend configuration — values injected at build time via Vite env vars.
 * Set these in .env.local or as environment variables before building.
 */
export const config = {
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT ?? 'http://localhost:3000/prod',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN ?? '',
  cognitoRedirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI ?? 'http://localhost:5173/callback',
  cognitoLogoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI ?? 'http://localhost:5173/',
};
